module.exports = __webpack_public_path__ + "static/img/IMG(3).9ceae2ae.jpg";